import { cloneDeep } from 'lodash';

import { useDimensionPanelStore } from '@components/dimensions/store';
import { updatePreset } from '@components/dimensions/utils/updatePresetUtil';
import { IDimension } from '@src/emp-3.0/types';
import store from '@src/store';
import { applyFilter } from '@store/filterContainer/actions';
import { getFilterFromRules, getRulesFromFilter } from '@utils';

export const validateGlobalFilterByDimensions = (dimensionsList: IDimension[] = []) => {
  const { dispatch, getState } = store;
  const appliedFilters = getState().common.appliedFilters;
  const appliedFilter = appliedFilters[0] ?? {};
  const clonedAppliedFilter = cloneDeep(appliedFilter);
  clonedAppliedFilter.rule = clonedAppliedFilter.rule.filter((andRule) => {
    return andRule.some((orRule) => {
      return dimensionsList.some((dimension) => dimension.dimension_name === orRule.field);
    });
  });
  const tempRules = getRulesFromFilter(clonedAppliedFilter.rule, true);
  clonedAppliedFilter.name = getFilterFromRules(tempRules, true).name;
  dispatch(applyFilter(clonedAppliedFilter));
};

export const validatePresetByDimensions = (dimensionsList: IDimension[] = []) => {
  const { preset, setPreset } = useDimensionPanelStore.getState();
  if (!preset) return;
  const dimensions = preset?.dimensions ?? [];
  const newDimensions = [...dimensions].filter((dimensionItem) =>
    dimensionsList.some((dimension) => dimension.dimension_name === dimensionItem.dimensionName),
  );
  const newPreset = { ...preset };
  newPreset.dimensions = newDimensions;
  setPreset({ ...newPreset });
  updatePreset(newPreset.id, { ...newPreset });
};
